module.exports = __webpack_public_path__ + "static/media/Ubisoft.97cc2b97.png";